<div class="app-version-banner" *ngIf="visible">
  <div class="banner-content" *transloco="let t; read: 'app_version_banner'">
    <span class="banner-message">{{ t('message') }}</span>
    <div class="banner-actions">
      <button 
        type="button" 
        class="banner-button banner-button-primary"
        (click)="onReload()">
        {{ t('reload_button') }}
      </button>
      <button 
        type="button" 
        class="banner-button banner-button-secondary"
        (click)="onDismiss()">
        {{ t('dismiss_button') }}
      </button>
    </div>
  </div>
</div>
